/* eslint-disable */
import HttpService from '../HttpService'

export default class AppConfigurationService {
  constructor() {
    this._httpService = new HttpService('/sdi');
  }

  async IsCardNumberRequeried(carrierId, movementType) {
    const url = new URLSearchParams();
    url.append('carrierId', carrierId);
    url.append('movementType', movementType);
    return await this._httpService.get('/app-configuration-field/card_number_required', url);
  }

  async getAppConfigurationField(key, params) {
    const queryParams = new URLSearchParams(params);
    return await this._httpService.get('/app-configuration-field/' + key, queryParams);
  }
}
